import { mutations as MUTATION, actions as ACTION } from "./types";
import { Api, ApiUrl } from "../../services";
import i18n from "@/i18n.js";
const actions = {
  [ACTION.TUTORIAL_GET_PLAYLIST](store, playlistId) {
    let id = "";
    if (playlistId == "getting-started") {
      id = "PLoyQ7pcHx_pRj6sMwBdLihO8SvBjZaJpn";
    } else if (playlistId == "about-us-page") {
      id = "PLoyQ7pcHx_pQ8lbYAJYzjm_ky128Kgymy";
    } else if (playlistId == "high-converting-product-pages") {
      id = "PLoyQ7pcHx_pQrXJYRkM9Q75DqiXHp90SJ";
    } else {
      id = playlistId;
    }

    const key = "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo";
    const state = store.state;

    state.loading = true;
    Api.youtube
      .get(ApiUrl.youtube.playlist(id, key))
      .then(res => {
        if (res?.data) {
          state.loading = false;
          state.fetched = true;
          store.commit(MUTATION.TUTORIAL_FETCH_PLAYLIST, {
            id: playlistId,
            items: res.data.items
          });
        }
      })
      .catch(() => {
        state.loading = false;
        state.error = i18n.t("youtube.cantGetPlaylist");
      });
  },
  [ACTION.TUTORIAL_GET_PLAYLISTS](store) {
    const state = store.state.topic;

    state.loading = true;
    const key = "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo";
    Api.youtube
      .get(ApiUrl.youtube.playlists(key))
      .then(res => {
        if (res?.data) {
          state.fetched = true;
          state.loading = false;
          store.commit(MUTATION.TUTORIAL_FETCH_PLAYLISTS, res.data.items);
        }
      })
      .catch(() => {
        state.loading = false;
        state.error = i18n.t("youtube.cantGetPlaylists");
      });
  },
  [ACTION.FAQS_OPEN_MODAL](store) {
    const { state } = store
    state.faqs.isModalActive = true
  },
  [ACTION.FAQS_CLOSE_MODAL](store) {
    const { state } = store
    state.faqs.isModalActive = false
  },
  [ACTION.STARTED_GUIDE_OPEN](store) {
    const { state } = store
    state.onboarding.isModalActive = true
  },
  [ACTION.STARTED_GUIDE_CLOSE](store) {
    const { state } = store
    state.onboarding.isModalActive = false
  },
  [ACTION.SECTION_GET]: async (store) => {
    const { state } = store
    // alert(ApiUrl.sections.get)
    Api.base.get(ApiUrl.base.sections.get).then(
      res => {
        if (res?.data){
          state.sections = res.data
        }
      }
    )
    .catch(()=>{

    })
  }
};

export default actions;
